import {
  Ban,
  CircleUser,
  Coins,
  Euro,
  HandCoins,
  type LucideIcon,
  MailMinus,
  ReceiptEuro,
  Scale,
} from "lucide-react";

/** Port of apps/admin-dashboard/src/utils/config/constants/monetary-demand-types.ts. */

export type MonetaryDemandType =
  | "EC261_2004"
  | "MC99_FINANCIAL_DAMAGES"
  | "LACK_OF_INFORMATION_NOTICE"
  | "MORAL_PREJUDICE"
  | "ABUSIVE_RESISTANCE"
  | "ARTICLE_700_CPC"
  | "PROCEDURE_COSTS"
  | "EC261_ASSISTANCE_DUTY";

interface MonetaryDemandTypeEntry {
  icon: LucideIcon;
  value: MonetaryDemandType;
  label: string;
  /** Amount is auto-computed (from EC261/MC99 rules or expenses) — not manually creatable/editable. */
  isComputed: boolean;
}

export const MONETARY_DEMAND_TYPES_MAP: Record<MonetaryDemandType, MonetaryDemandTypeEntry> = {
  EC261_2004: {
    icon: Euro,
    value: "EC261_2004",
    label: "Montant forfaitaire (261/2004)",
    isComputed: true,
  },
  MC99_FINANCIAL_DAMAGES: {
    icon: Coins,
    value: "MC99_FINANCIAL_DAMAGES",
    label: "Préjudices financiers",
    isComputed: true,
  },
  LACK_OF_INFORMATION_NOTICE: {
    icon: MailMinus,
    value: "LACK_OF_INFORMATION_NOTICE",
    label: "Défaut de notice d'information",
    isComputed: false,
  },
  MORAL_PREJUDICE: {
    icon: CircleUser,
    value: "MORAL_PREJUDICE",
    label: "Préjudice moral",
    isComputed: false,
  },
  ABUSIVE_RESISTANCE: {
    icon: Ban,
    value: "ABUSIVE_RESISTANCE",
    label: "Résistance Abusive",
    isComputed: false,
  },
  ARTICLE_700_CPC: {
    icon: Scale,
    value: "ARTICLE_700_CPC",
    label: "Article 700 du CPC",
    isComputed: false,
  },
  PROCEDURE_COSTS: {
    icon: ReceiptEuro,
    value: "PROCEDURE_COSTS",
    label: "Dépens",
    isComputed: false,
  },
  EC261_ASSISTANCE_DUTY: {
    icon: HandCoins,
    value: "EC261_ASSISTANCE_DUTY",
    label: "Devoir d'assistance (EC261)",
    isComputed: true,
  },
};

/** Selectable types for the create/edit form — computed types can't be manually set. */
export const CREATABLE_MONETARY_DEMAND_TYPES = Object.values(MONETARY_DEMAND_TYPES_MAP).filter(
  (entry) => !entry.isComputed,
);
